import { render, staticRenderFns } from "./DrawFloorVulkan.vue?vue&type=template&id=490e716b&scoped=true"
import script from "./DrawFloorVulkan.vue?vue&type=script&lang=js"
export * from "./DrawFloorVulkan.vue?vue&type=script&lang=js"
import style0 from "./DrawFloorVulkan.vue?vue&type=style&index=0&id=490e716b&prod&lang=scss&scoped=true"
import style1 from "./DrawFloorVulkan.vue?vue&type=style&index=1&id=490e716b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490e716b",
  null
  
)

export default component.exports